const STORAGE_KEY = "imgAuthSession";

let session = {
  userId: null,
  deviceKey: null,
  accessToken: null,
};

export function setImageAuth({ userId, deviceKey, accessToken }) {
  session = { userId, deviceKey, accessToken };
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(session));
  } catch (e) {
    console.error("Failed to persist image auth session:", e);
  }
}

export function getImageAuth() {
  return session;
}

export function clearImageAuth() {
  session = { userId: null, deviceKey: null, accessToken: null };
  try {
    localStorage.removeItem(STORAGE_KEY);
  } catch (e) {}
}

// Rehydrate immediately on module load (covers page refresh)
(function loadPersisted() {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (raw) session = JSON.parse(raw);
  } catch (e) {}
})();

// Keep this tab's in-memory copy in sync if another tab logs in/out/refreshes token
window.addEventListener("storage", (e) => {
  if (e.key === STORAGE_KEY) {
    try {
      session = e.newValue
        ? JSON.parse(e.newValue)
        : { userId: null, deviceKey: null, accessToken: null };
    } catch (err) {}
  }
});
